var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgChatbubbleShining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 60,
    viewBox: "0 0 118 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9344 44.2185H51.6764H28.5654C25.6307 44.2185 23.0147 43.3603 21.1573 42.0243C19.2982 40.687 18.2627 38.929 18.2627 37.0918V20.3591C18.2627 18.5219 19.2982 16.7639 21.1573 15.4266C23.0147 14.0906 25.6307 13.2324 28.5654 13.2324H88.7299C91.6592 13.2324 94.2727 14.0904 96.1289 15.4264C97.9868 16.7637 99.0224 18.5218 99.0224 20.3591V37.0918C99.0224 38.9291 97.9868 40.6872 96.1289 42.0245C94.2727 43.3605 91.6592 44.2185 88.7299 44.2185H65.5689H65.3209V44.2473C63.4915 44.5902 61.7983 45.4532 60.4419 46.7341C59.7172 47.4184 59.105 48.2065 58.6227 49.0685C58.1403 48.2065 57.5282 47.4184 56.8035 46.7341C55.4667 45.4718 53.8028 44.6153 52.004 44.2626V44.2185H51.9344Z",
    stroke: "url(#paint0_linear_4770_89614)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90991 42L3.90991 46.33L0 48.45L4.27979 50.76L6.37988 54.55L8.37988 50.41L12.3799 48.15L8.22998 46.15L5.90991 42Z",
    fill: "#F6BC4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7695 50.3594L12.3896 53.3594L9.67969 54.8294L12.6797 56.4394L14.1497 59.0594L15.5696 56.1894L18.3296 54.6194L15.4497 53.2394L13.7695 50.3594Z",
    fill: "#F6BC4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 0L102.91 4.33002L99 6.45001L103.28 8.76001L105.38 12.55L107.38 8.40997L111.38 6.14996L107.23 4.14996L104.91 0Z",
    fill: "#F6BC4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.77 8.35938L111.39 11.3594L108.68 12.8294L111.68 14.4394L113.15 17.0594L114.57 14.1894L117.33 12.6194L114.45 11.2394L112.77 8.35938Z",
    fill: "#F6BC4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4770_89614",
    x1: 15.1772,
    y1: 32.4569,
    x2: 100.859,
    y2: 32.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55286",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#DB3F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35884",
    stopOpacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgChatbubbleShining);
export default __webpack_public_path__ + "static/media/bg-chatbubble-shining.db59af722b322aa03d79ea1ef55e6f00.svg";
export { ForwardRef as ReactComponent };